import { Card, CardContent } from "@/components/ui/card";
import {
  BookOpen,
  Search,
  Compass,
  Calendar,
  Video,
  Zap,
  Users,
  Award,
  UserPlus,
} from "lucide-react";

const features = [
  {
    icon: BookOpen,
    title: "Alle Kurse",
    description: "Vollständiger Zugang zu über 50 Kursen",
  },
  {
    icon: Search,
    title: "Intelligente Suche",
    description: "Finde in Sekunden das Richtige",
  },
  {
    icon: Compass,
    title: "Themenreisen",
    description: "Geführte Lernpfade zu vielen Themen",
  },
  {
    icon: Calendar,
    title: "Liederwerkstatt",
    description: "Monatliche Live-Sessions + Archiv",
  },
  {
    icon: Video,
    title: "Webinare",
    description: "Exklusive Webinare + Aufzeichnungen",
  },
  {
    icon: Zap,
    title: "Miko KI",
    description: "Unbegrenzte Anfragen",
  },
  {
    icon: Users,
    title: "Community",
    description: "Austausch mit anderen Fachkräften",
  },
  {
    icon: Award,
    title: "Zertifikate",
    description: "Nachweise für jede Fortbildung",
  },
  {
    icon: UserPlus,
    title: "Gemeinsam lernen",
    description: "Teile mit 2 Kolleg:innen",
  },
];

const MembershipFeatureGrid = () => {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Alles in einer Mitgliedschaft
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Voller Zugang zu allen Funktionen und Inhalten – ohne Einschränkungen
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {features.map((feature, idx) => (
            <Card
              key={idx}
              className="group hover:border-primary/30 hover:shadow-lg transition-all duration-300 animate-fade-in"
              style={{ animationDelay: `${idx * 0.05}s` }}
            >
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors">
                    <feature.icon className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground mb-1">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-muted-foreground">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <p className="text-center text-sm text-muted-foreground mt-10 max-w-2xl mx-auto">
          Für Kitas & Einrichtungen gibt es zusätzlich das{" "}
          <a href="/musik-kita" className="text-primary font-medium hover:underline">
            Musik-Kita-Paket
          </a>{" "}
          – mit Team-Zugang, Eltern-Registrierung und Gütesiegel.
        </p>
      </div>
    </section>
  );
};

export default MembershipFeatureGrid;
